import { QueryString } from '@/types'

export default function isLoadedInAppView(query: QueryString) {
  const { NEGOTIATORAPP, negotiatorapp } = query
  return NEGOTIATORAPP !== undefined || negotiatorapp !== undefined
}
